import moment from "moment";
import React, { Component } from "react";
import { PersonalInformationContainer } from "./personal-information-style"
import SelectBox from "../../../../../../components/select-box/select-box";
import CalendarBox from "../../../../../../components/calendar-box/calendar-box";
import DicotomicButton from "../../../../../../components/dicotomic-button";
import InputBox from "../../../../../../components/input-box/input-box";
import DOC_TYPES from "../../../../../../constants/doc_types";
import CheckboxItemLayout from "../../../../../../components/checkbox-item/checkbox-item-layout";
import SearchBox from "../../../../../../components/search-box-mediadores/search-box";
import { genderOptions, getDocumentTypes, getFilteredCountries, isValidCif, isValidDocumentID, validateDocType, validateStandarisedFieldsHealthHiring } from "../../../../../../utils/validation";
import { DefaultPersonalData, DefaultProfessionData, DefaultValueFormHealth, PersonalDataDto } from "./personal-information-dto/personal-information-dto";
import { calcAge, checkDate, convertDateToString } from "../../../../../../utils/utility";
import { deepGet } from "../../../../../../utils/utility";
import { withGeneral } from "../../../../../../context/mixin/with-general";
import { LabelTooltip } from "../../../../../../components/form";
import { getCountriesList } from "../../../../../../utils/countries";
import { withDynamicProducts } from "../../../../../../context/mixin/with-dynamic-products";
import WASISAServices from "../../../../../../services/WASISAServices";
import { DOC_NUMBER_MAX_LENGTH } from "../../../../../../constants";

export interface PersonalData {
  name: string;
  lastname1: string;
  lastname2?: string;
  birthDate: string;
  civilStatus: string;
  gender: string;
  nationality: string | undefined;
  nationalityLabel: string;
  docType: string;
  docNumber: string;
  passportDate: string | undefined;
  relationship?: string;
  profession: {
    value: string,
    code: string,
    other: string,
  };
  sameAsTaker: boolean;
  physicalPerson: boolean;
  tc2?: string;
  reta?: string;
  responsable?: string;
  isStudent?: boolean;
  repatriationCountry?: string;
  repatriationCountryLabel?: string;
}

interface PersonalInformationProps {
  validate: {
    validateRequest: boolean;
    isValidated: boolean;
  },
  onValidated: (person: PersonalData) => void;
  onCleanForm?: boolean;
  insured?: boolean;
  handlePersonChange?: any;
  onCheckTakerData?: any;
  setLoading?: Function;
  isReadOnly?: boolean;
  onAnyChange: Function;
  insureds?: PersonalData[];
  taker?: PersonalData;
  insuredIndex: number;
  currentHealthStep: number;
  physicalPersonValue?: boolean;
  productFields?: any;
  countries: any;
  isTaker?: boolean;
  allowForeignAddress?: Function;
  isVisaProduct?: boolean;
  allProducts: any;
}

interface PersonalInformationState {
  person: PersonalDataDto;
  stateDisabled: boolean;
  professionsList: any[];
  professionsFiltered: any[];
  countries: any[];
  countriesFiltered: any[];
  previousData: PersonalDataDto;
  prevDocType: string;
  repatriationCountriesFiltered: any[];
  showRepatriationTooltip: boolean;
}

class PersonalInformation extends Component<PersonalInformationProps, PersonalInformationState> {
  _searchWaiter: any = null;

  constructor(props: PersonalInformationProps) {
    super(props)

    this.state = {
      person: !props.insured
      ? this.getPersonalDataDto(props.taker)
      : (props.insureds && props.insuredIndex > -1 && props.insureds[props.insuredIndex]
        ? this.getPersonalDataDto(props.insureds[props.insuredIndex], props.insureds[props.insuredIndex].sameAsTaker)
        : DefaultPersonalData()),
      stateDisabled: props.isReadOnly ? props.isReadOnly : false,
      professionsList: [],
      professionsFiltered: [],
      countries: [],
      countriesFiltered: [],
      repatriationCountriesFiltered: [],
      previousData: DefaultPersonalData(),
      prevDocType: !props.insured && props.taker
        ? props.taker.docType
        : (props.insureds && props.insuredIndex > -1 && props.insureds[props.insuredIndex]
          ? props.insureds[props.insuredIndex].docType
          : ''),
      showRepatriationTooltip: false,
    }
  }

  getPersonalDataDto(personData?: PersonalData, disabled: boolean = false): PersonalDataDto {
    const countries = this.state && this.state.countries;
    const country = personData && personData.nationality && countries && countries.length > 0 && countries.find((country) => country.value === personData.nationality);
    const hasRepatriationCountry = this.props.insured && this.props.isVisaProduct;
    let countryRepatriation;
    if (hasRepatriationCountry) {
      countryRepatriation = personData && personData.repatriationCountry && countries && countries.length > 0 && countries.find((country) => country.value === personData.repatriationCountry);
    }

    const newPerson = (!personData || Object.keys(personData).length === 0) ? DefaultPersonalData() : {
      name: this.getValueFormHealth(personData.name, disabled),
      lastName1: this.getValueFormHealth(personData.lastname1, disabled),
      lastName2: this.getValueFormHealth(personData.lastname2, disabled),
      birthDate: this.getValueFormHealth(personData.birthDate ? checkDate(personData.birthDate) : '', disabled),
      civilStatus: this.getValueFormHealth(personData.civilStatus, disabled),
      docType: this.getValueFormHealth(personData.docType, disabled),
      docNumber: calcAge(moment(personData.birthDate).format("DD/MM/YYYY")) > 16 && personData.docType === 'MENOR'
        ? this.getValueFormHealth('', disabled) :
        this.getValueFormHealth(personData.docNumber, disabled),
      sex: this.getValueFormHealth(personData.gender, disabled),
      nationality: {
        value: personData.nationalityLabel ? personData.nationalityLabel : country ? country.label : '',
        errorCode: '',
        disabled: disabled,
        code: personData.nationality ? personData.nationality : country ? country.value : ''
      },
      nationalityLabel: personData.nationalityLabel ? personData.nationalityLabel : country ? country.value : '',
      relationship: this.getValueFormHealth(personData.relationship, disabled),
      profession: {
        value: personData.profession ? personData.profession.value : "",
        code: personData.profession ? personData.profession.code : "",
        errorCode: "",
        disabled: false,
        other: {
          value: personData.profession && personData.profession.value === 'OTRA' && personData.profession.other ? personData.profession.other : "",
          errorCode: "",
          disabled: false,
        }
      },
      passportDate: this.getValueFormHealth(personData.passportDate ? personData.passportDate : "", disabled),
      sameAsTaker: personData.sameAsTaker,
      physicalPerson: personData.physicalPerson !== undefined ?
        personData.physicalPerson :
        this.props.physicalPersonValue ?
          this.props.physicalPersonValue :
          true,
      tc2: this.getValueFormHealth(personData.tc2, disabled),
      reta: this.getValueFormHealth(personData.reta, disabled),
      responsable: this.getValueFormHealth(personData.responsable, disabled),
      isStudent: personData.isStudent || false,
      ...(hasRepatriationCountry ? {
        repatriationCountry: {
          value: personData.repatriationCountryLabel ? personData.repatriationCountryLabel : countryRepatriation ? countryRepatriation.label : '',
          errorCode: '',
          disabled: disabled,
          code: personData.repatriationCountry ? personData.repatriationCountry : countryRepatriation ? countryRepatriation.value : ''
        },
        repatriationCountryLabel: personData.repatriationCountryLabel ? personData.repatriationCountryLabel : countryRepatriation ? countryRepatriation.value : '',
      } : ""),
    };

    return newPerson;
  }


  getValueFormHealth(value: string | undefined, disabled: boolean) {
    return {
      value: value ? value : "",
      errorCode: '',
      disabled: disabled,
      code: ''
    };
  }

  getDocTypes(birthDate: string | undefined, nationality: string | undefined): { [key: string]: string; }[] {
    const { isTaker, isVisaProduct, isReadOnly } = this.props;
    const sameAsTaker = deepGet(this.state, "person.sameAsTaker", false);
    
    if (isTaker) {
      if (isVisaProduct && sameAsTaker) return DOC_TYPES.takerHealthVisa;
      else return getDocumentTypes(nationality, true, true);
    }

    if (isVisaProduct) {
      return DOC_TYPES.insuredHealthVisa;
    }

    var age = 0;
    if (birthDate) age = calcAge(birthDate);
    const isUnderAgeDisabled = !(age < 18 || !!isReadOnly)
    
    return getDocumentTypes(nationality, true, isUnderAgeDisabled);

  }

  componentWillReceiveProps(nextProps: PersonalInformationProps) {
    let { validate } = this.props;

    if (nextProps.validate.validateRequest) {
      validate.validateRequest = false;
      validate.isValidated = this.validateForm();
    }
    else if (nextProps.onCleanForm) {
      this.cleanForm();
    }
    // else if (this.props.insuredIndex === -1 && nextProps.insured && nextProps.insureds && nextProps.insureds.length === 0 ) {
    //   const data = JSON.parse(JSON.stringify(nextProps.taker));
    //   this.completeInsuredData(data, true);
    // }
    else if (this.props.insuredIndex !== nextProps.insuredIndex) {
      const insuredIndex: number = nextProps.insureds && nextProps.insureds.length === 1 ? 0 : nextProps.insuredIndex;
      if (nextProps.insuredIndex !== -1 && nextProps.insureds &&
        nextProps.insureds.length > 0 && nextProps.insureds[insuredIndex] && nextProps.insureds[insuredIndex].sameAsTaker) {

        const data = JSON.parse(JSON.stringify(nextProps.taker));
        data.profession = JSON.parse(JSON.stringify(nextProps.insureds[insuredIndex].profession));
        data.isStudent = nextProps.insureds[insuredIndex].isStudent || false;

        if (nextProps.insureds[insuredIndex].repatriationCountry) {
          data.repatriationCountry = JSON.parse(JSON.stringify(nextProps.insureds[insuredIndex].repatriationCountry));
          data.repatriationCountryLabel = JSON.parse(JSON.stringify(nextProps.insureds[insuredIndex].repatriationCountryLabel));
        }
        this.completeInsuredData(data, true);
        // Nacionalida

      }
      else {
        this.completeInsuredData(insuredIndex === -1 ? nextProps.taker : nextProps.insureds ? nextProps.insureds[insuredIndex] : undefined);
      }
    }
  }

  async componentDidMount() {
    let { professionsList, countries, person } = this.state;
    const { insuredIndex, insureds, isTaker, allProducts } = this.props;

    const product_internalName = localStorage.getItem('internalName')
    if(!(product_internalName && Object.keys(allProducts).length && allProducts[product_internalName])) return;

    professionsList = await WASISAServices.getProfessions({
      setLoading: this.props.setLoading,
      businessLine: allProducts[product_internalName].ln_linea_negocio
    });

    countries = await getCountriesList(this.props.countries, this.props.setLoading);

    countries.map((country: any) => country.label = country.label.toUpperCase());

    let filterProfessions = professionsList
      .sort(function (a: any, b: any) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });


     if (!isTaker && insureds && insuredIndex > -1 && insureds[insuredIndex]) {
      if (insureds[insuredIndex].nationality && !insureds[insuredIndex].nationalityLabel) {
        const country = person.nationality && countries.length > 0 && countries.find((country) => country.value === insureds[insuredIndex].nationality);
        person.nationality = {
          value: country ? country.label : '',
          errorCode: '',
          disabled: insureds[insuredIndex].sameAsTaker,
          code: person.nationality ? person.nationality : country ? country.value : ''
        };
        person.nationalityLabel = country ? country.label : '';

        if (this.props.isVisaProduct) {
          const countryRepatriation = person.repatriationCountry && countries.length > 0 && countries.find((country) => country.value === insureds[insuredIndex].repatriationCountry);
          person.repatriationCountry = {
            value: countryRepatriation ? countryRepatriation.label : '',
            errorCode: '',
            disabled: insureds[insuredIndex].sameAsTaker,
            code: person.repatriationCountry ? person.repatriationCountry : countryRepatriation ? countryRepatriation.value : ''
          };
          person.repatriationCountryLabel = countryRepatriation ? countryRepatriation.label : '';
        }
        this.setState({ person });
      }
    }

    this.setState({ professionsList: filterProfessions, countries });

  }

  async handleValueChange(input: string, value: any) {
    let { person, prevDocType } = this.state;
    const { taker } = this.props;
    if (!(input === 'sex' && (taker && value === taker.gender)) &&
      !(input === 'docType' && (taker && value === taker.docType))) {
      this.props.onAnyChange();
    }

    switch (input) {
      case 'name':
      case 'lastName1':
      case 'lastName2':
      case 'birthDate':
      case 'docNumber':
      case 'sex':
      case 'docType':
      case 'passportDate':
      case "tc2":
      case "reta":
      case "responsable":
        value = typeof value === "string" ? value.toUpperCase() : value;
        Object.keys(person).forEach((k: string) => {
          if (k === input) {
            person[k].errorCode = '';
            person[k].value = value;

            const isOnChangeEvent = true;
            validateStandarisedFieldsHealthHiring(value, input, isOnChangeEvent, person);

            if (input === 'docType') {
              person.docNumber.disabled = value === "MENOR" ? true : person.docNumber.disabled;
              person.docNumber = (person.docNumber.disabled && value === "MENOR") ? this.getValueFormHealth(undefined, true) : value !== "MENOR" && prevDocType === "MENOR" ? this.getValueFormHealth(undefined, false) : person.docNumber;
              prevDocType = value;
            }

            if (input === 'birthDate') {
              var age = calcAge(value);
              prevDocType = person.docType.value;
              
              if (!isNaN(age) && age > 17) {
                person.docNumber.disabled = person.docType.value === "MENOR";
              }
            }
          }
        });
        break;
      case 'relationship':
        person.relationship.value = value;
        break;

      case 'profession':
        person.profession.value = value.label;
        person.profession.code = value.value;
        person.profession.errorCode = '';
        break;

      case 'otherProfession':
        value = value.toUpperCase();
        person.profession.other.value = value;
        person.profession.other.errorCode = '';
        break;

      case 'nationality':
        person.nationality.value = value.label;
        person.nationality.code = value.value;
        person.nationality.errorCode = '';
        person.nationalityLabel = value.label;
        if(value.value !== "ESPA" && person.lastName2.errorCode === 'required'){
          person.lastName2.errorCode = '';
        }
        break;

      case "repatriationCountry":
        person = {
          ...person,
          repatriationCountry: {
            value: value.label,
            code: value.value,
            errorCode: "",
            disabled: person.repatriationCountry ? person.repatriationCountry.disabled : false,
          },
          repatriationCountryLabel: value.label,
        }
        break;

      default:
        break;
    }

    this.setState({ person, prevDocType });
  }

  validateForm(): boolean {
    let { person } = this.state;
    const { isTaker, isReadOnly } = this.props
    let noErrors = true;

    if (person.physicalPerson) {

      Object.keys(person).forEach( (key) => {
        const value = (person as any)[key] ? (person as any)[key].value : '';
        const isOnChangeEvent = false;
        let validation = validateStandarisedFieldsHealthHiring(value, key, isOnChangeEvent, person);
        if(key === 'docType'){
          const birthDate = person.birthDate.value
          const isUnderAgeDisabled = !!isTaker || (!!birthDate ? !(calcAge(birthDate) < 18 || !!isReadOnly) : false)
          validation = validateDocType(person.docType.value, person.nationality.value, person.birthDate.value, true, true, isUnderAgeDisabled, 18)
          person[key] = {
            ...person[key],
            errorCode: validation.errorCode,
          }
        }
        if(validation && validation.isError) noErrors = false;
      });
      
      if (person.nationality.value.length === 0) {
        person.nationality.errorCode = 'required';
        noErrors = false;
      }
      if (this.props.insured && this.props.isVisaProduct && person.repatriationCountry && person.repatriationCountry.value.length === 0) {
        person.repatriationCountry.errorCode = 'required';
        noErrors = false;
      }
      if (person.docType.value !== 'MENOR' && person.docNumber.value.length === 0) {
        person.docNumber.errorCode = 'required';
        noErrors = false;
      }
      else if (!isValidDocumentID(person.docNumber.value, person.docType.value === 'MENOR' ? 'NIF' : person.docType.value)) {

        if (person.docType.value !== 'MENOR' && person.docNumber.value.length > 0) {
          person.docNumber.errorCode = 'invalid-document-dni';
          noErrors = false;
        }

        if (person.docType.value !== 'MENOR' && person.docType.value === 'NIF' && person.docNumber.value.length === 9) {
          person.docNumber.errorCode = 'invalid-document-dni';
          noErrors = false;
        }
        else {
          if (person.docType.value !== 'MENOR') {
            person.docNumber.errorCode = 'invalid-format';
            noErrors = false;
          }
        }
      }
      else if (this.props.insured && this.props.insureds && this.props.insureds.length) {
        this.props.insureds.forEach((insured: any, index: number) => {
          if (insured.docNumber === person.docNumber.value && index !== this.props.insuredIndex) {
            person.docNumber.errorCode = 'repeated-document-number';
            noErrors = false;
          }
        });
        if (!person.sameAsTaker && this.props.insured && this.props.taker && person.docNumber.value === this.props.taker.docNumber) {
          person.docNumber.errorCode = 'repeated-document-number-taker';
          noErrors = false;
        }
      }
      if (person.sex.value.length === 0) {
        person.sex.errorCode = 'required';
        noErrors = false;
      }
      if (person.docType.value.length === 0) {
        person.docType.errorCode = 'required';
        noErrors = false;
      }
      if (person.docType.value === 'PAS' && person.passportDate.value.length === 0) {
        person.passportDate.errorCode = 'required';
        noErrors = false;
      }
      if (this.props.insured && person.profession.value === 'OTRA') {
        if (person.profession.other.value.length === 0) {
          noErrors = false;
          person.profession.other.errorCode = 'required';
        }
      }

      if (
        !this.props.insured &&
        !(person.docNumber.value === '') &&
        this.props.insureds
      ) {

        const insured = this.props.insureds.find((persona: PersonalData) => (
          persona.docNumber === person.docNumber.value && !persona.sameAsTaker
        ))

        if (insured) {
          const isDuPlicate = this.props.isVisaProduct ? !person.sameAsTaker : true;
          if (isDuPlicate) {
            noErrors = false;
            person.docNumber.errorCode = 'repeated-document-number-insured';
          }
        }

      }
    }
    else {
      if (!person.name.value) {
        person.name.errorCode = 'required';
        noErrors = false;
      }
      else if (!isValidCif(person.docNumber.value)) {
        person.docNumber.errorCode = 'invalid-format';
        noErrors = false;
      }
      if (!person.docNumber.value) {
        person.docNumber.errorCode = 'required';
        noErrors = false;
      }
      if (!person.responsable.value) {
        person.responsable.errorCode = 'required';
        noErrors = false;
      }
    }

    if (noErrors) {
      if (this.props.onValidated) {
        if (person.physicalPerson) {
          if (person.docType.value === 'MENOR' && !person.docNumber.value && this.props.insureds) {
            let minorSequencial = 0;
            this.props.insureds.map((insured: any) => {
              if (insured.docType === 'MENOR' && insured.docNumber.length < 2) {
                if (insured.docNumber > minorSequencial) {
                  minorSequencial = insured.docNumber;
                }
              }
            });
            person.docNumber.value = String(Number(minorSequencial) + 1);
            person.docNumber.disabled = true;
          }

          this.props.onValidated(
            {
              name: person.name.value,
              lastname1: person.lastName1.value,
              lastname2: person.lastName2.value,
              birthDate: person.birthDate.value,
              docType: person.docType.value,
              civilStatus: person.civilStatus.value,
              docNumber: person.docNumber.value,
              passportDate: person.passportDate.value,
              gender: person.sex.value,
              nationality: typeof person.nationality.code === "string" ? person.nationality.code : deepGet(person, "nationality.code.code", ""),
              nationalityLabel: person.nationality.value,
              relationship: person.relationship.value,
              profession: {
                value: person.profession.value,
                code: person.profession.code,
                other: person.profession.other.value
              },
              sameAsTaker: person.sameAsTaker,
              physicalPerson: person.physicalPerson,
              tc2: person.tc2.value,
              reta: person.reta.value,
              responsable: person.responsable.value,
              isStudent: person.isStudent,
              ...(this.props.insured && this.props.isVisaProduct ? {
                repatriationCountry: person.repatriationCountry && typeof person.repatriationCountry.code === "string" ? person.repatriationCountry.code : deepGet(person, "repatriationCountry.code.code", ""),
                repatriationCountryLabel: person.repatriationCountry && person.repatriationCountry.value || "",
              } : ""),
            }
          );
        }
        else {
          this.props.onValidated(
            {
              name: person.name.value,
              docNumber: person.docNumber.value,
              sameAsTaker: person.sameAsTaker,
              lastname1: "",
              lastname2: "",
              birthDate: new Date().toLocaleDateString(),
              docType: 'CIF',
              civilStatus: "",
              passportDate: undefined,
              gender: "",
              nationality: "",
              nationalityLabel: "",
              relationship: "",
              profession: {
                value: "",
                code: "",
                other: ""

              },
              physicalPerson: false,
              tc2: person.tc2.value,
              reta: person.reta.value,
              responsable: person.responsable.value,
              isStudent: person.isStudent,
              ...(this.props.insured && this.props.isVisaProduct ? {
                repatriationCountry: "",
                repatriationCountryLabel: ""
              } : "")
            }
          );
        }
      }
    }

    this.setState({ person });
    return noErrors;
  }

  cleanForm() {
    const hasRepatriationCountry = this.props.insured && this.props.isVisaProduct;
    this.setState({
      person: DefaultPersonalData(hasRepatriationCountry),
      stateDisabled: false,
      previousData: DefaultPersonalData(hasRepatriationCountry),
      countriesFiltered: this.state.countries,
      professionsFiltered: this.state.professionsList,
      repatriationCountriesFiltered: this.state.countries,
    });
  }

  completeInsuredData(personData?: PersonalData, isTakerData: boolean = false) {
    let { person, prevDocType } = this.state;
    person = this.getPersonalDataDto(personData, personData ? personData.sameAsTaker ? personData.sameAsTaker : isTakerData : false);

    if (isTakerData) {
      person.sameAsTaker = isTakerData;
    }

    prevDocType = person.docType.value;

    this.setState({ person, prevDocType });
  }

  completeFormTakerData(person: PersonalDataDto) {
    let getPreviousData = (person: PersonalDataDto) => {
      const previousData: PersonalDataDto = JSON.parse(JSON.stringify(person));
      previousData.birthDate.errorCode = "";
      previousData.name.errorCode = "";
      previousData.lastName1.errorCode = "";
      previousData.lastName2.errorCode = "";
      previousData.birthDate.errorCode = "";
      previousData.docNumber.errorCode = "";
      previousData.docType.errorCode = "";
      previousData.sex.errorCode = "";
      previousData.nationality.errorCode = "";
      previousData.relationship.errorCode = "";
      previousData.profession.errorCode = "";
      previousData.profession.other.errorCode = "";
      previousData.passportDate.errorCode = "";
      previousData.responsable.errorCode = "";
      if (this.props.insured && this.props.isVisaProduct && previousData.repatriationCountry) {
        previousData.repatriationCountry.errorCode = "";
      }
      return previousData;
    }
    let { taker } = this.props;
    let { prevDocType } = this.state;

    let previousData = getPreviousData(person);
    if (taker) {
      if (!this.props.insured) {
        if (person.physicalPerson) {
          this.props.handlePersonChange('physical');
        }
        else {
          this.props.handlePersonChange('legal');
        }
      }

      taker.profession.value = previousData.profession.value;
      taker.profession.other = previousData.profession.other.value;
      person = this.getPersonalDataDto(taker, this.props.insured ? this.props.insured : false);
      person.sameAsTaker = true;

      prevDocType = person.docType.value

      this.setState({ person: person, previousData, prevDocType });
    }
  }

  handleCheckTakerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let { person } = this.state;
    const { allowForeignAddress, isTaker, insureds, isVisaProduct } = this.props;
    const isChecked = event.target.checked;

    if (isTaker && isVisaProduct) {
      if (allowForeignAddress) allowForeignAddress(!isChecked);
      if (isChecked) {
        // El tomador=asegurado solo puede usar pasaporte
        this.handleValueChange("docType", "PAS");
        // Añadimos datos del asegurado si viene de simulación
        const birthDate: unknown = insureds && insureds[0] && insureds[0].birthDate;
        if (birthDate && typeof birthDate === "string" && !birthDate.split("").includes('Z')) {
          const gender = insureds && insureds[0] && insureds[0].gender;
          this.handleValueChange('birthDate', birthDate);
          this.handleValueChange('sex', gender);
        }
      }
      this.setState({ person: { ...person, sameAsTaker: isChecked } });
      return;
    }

    person.sameAsTaker = !person.sameAsTaker;
    this.props.onCheckTakerData(person.sameAsTaker);

    if (person.sameAsTaker) {
      this.completeFormTakerData(person);
    }
    else {
      this.getPreviousData(person);
    }
  }

  handleCheckPerson = (personType: "legal" | "personal") => {
    const { person } = this.state;
    const { allowForeignAddress, isVisaProduct } = this.props;
    
    if (isVisaProduct) {
      this.setState({ person: { ...person, sameAsTaker: false } });
      // Persona Jurídica no puede ser dirección extranjera
      if (allowForeignAddress) allowForeignAddress(personType === "personal");
    }
  }

  handleCheckEstudiante = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { person } = this.state;
    this.setState({ person: { ...person, isStudent: event.target.checked } });
  }

  getPreviousData(person: PersonalDataDto) {
    let { previousData, prevDocType } = this.state;

    person.name = previousData.name;
    person.lastName1 = previousData.lastName1;
    person.lastName2 = previousData.lastName2;
    person.birthDate = previousData.birthDate;
    person.docType = previousData.docType;
    person.docNumber = previousData.docNumber;
    person.sex = previousData.sex;
    person.nationality = previousData.nationality;
    person.relationship = previousData.relationship;
    person.profession = previousData.profession;
    person.passportDate = previousData.passportDate;
    person.tc2 = previousData.tc2;
    person.reta = previousData.reta;
    person.responsable = previousData.responsable;
    if (this.props.insured && this.props.isVisaProduct && previousData.repatriationCountry) {
      person.repatriationCountry = previousData.repatriationCountry;
    }
    
    previousData = DefaultPersonalData();
    
    prevDocType = person.docType.value;
    
    this.setState({ previousData, person, prevDocType });
  }

  changeValueSearchBox(ev: any, arg1: string, arg2: string) {
    if (this._searchWaiter) {
      clearInterval(this._searchWaiter);
    }
    const { person } = this.state;
    const value: string = ev.target.value;

    // Reset searchBox values to default if delete prev data
    if (value.length < 1) {
      if (this.state.person.hasOwnProperty(arg2) && arg2 === "profession") {
        person.profession = DefaultProfessionData();
      }
      if (this.state.person.hasOwnProperty(arg2) && arg2 === "nationality") {
        person.nationality = DefaultValueFormHealth();
        person.nationalityLabel = '';
      }
      this.setState({ person });
    }

    if (value.length < 2) return;

    if (value.length >= 2) {
      switch (arg2) {

        case "profession":
          this.setState({
            professionsFiltered: this.state.professionsList.filter((prefession) =>
              prefession.label
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  value
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                )
            ),
          });
          break;
        case "nationality":
          this.setState({
            countriesFiltered: getFilteredCountries(value, this.state.countries)
          });
          break;
        case "repatriationCountry":
          this.setState({
            repatriationCountriesFiltered: this.state.countries.filter((country) =>
              country.label
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  value
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                )
            ),
          });
          break;
        default:
          break;
      }
    }
  }

  isFirstInsured = (): boolean => this.props.insuredIndex === 0 || (this.props.insuredIndex === -1 && (!this.props.insureds || this.props.insureds.length === 0));

  showCheckSameAsTaker = () => {
    const { currentHealthStep, isVisaProduct } = this.props;

    if (currentHealthStep === 1 && isVisaProduct && this.state.person.physicalPerson) {
      return true;
    }
    if (currentHealthStep === 2
        && this.props.taker
        && this.props.taker.physicalPerson
        && this.isFirstInsured()
        && !isVisaProduct) {
      return true;
    }
    return false;
  };

  render() {
    const { person, countriesFiltered, professionsFiltered, repatriationCountriesFiltered, showRepatriationTooltip } = this.state;
    const { isReadOnly, productFields } = this.props;
    return (

      <PersonalInformationContainer>
        <div className="content-wrapper bottomMargin20" ref={''}>
          <div className="personal-data-wrapper">
            <div className="data-title" id="data-personal">
              <h5>DATOS PERSONALES</h5>
            </div>
            <div className="personal-data-row">
              <div className="personal-data-item col-50">
              {this.showCheckSameAsTaker() && (
                <div className="bottomMargin20">
                  <CheckboxItemLayout
                    name='Los datos personales son los mismos que los del tomador'
                    checked={person.sameAsTaker}
                    onChange={this.handleCheckTakerChange}
                    showError={false}
                    checkboxText='El tomador de la póliza es el asegurado'
                    errorText='Error'
                    disabled={isReadOnly}
                  />
                </div>
              )}
              </div>

              <div className="personal-data-item col-50">
              {(this.props.currentHealthStep === 2 && this.props.taker && deepGet(productFields, "step2.isStudent", undefined) &&
                <div className="bottomMargin20">
                  <CheckboxItemLayout
                    name="Asegurado que va a realizar la formación"
                    checked={person.isStudent || false}
                    onChange={this.handleCheckEstudiante}
                    showError={false}
                    checkboxText="Asegurado que va a realizar la formación"
                    errorText=""
                    disabled={isReadOnly}
                  />
                </div>
              )}
              </div>
            </div>
            
            {(this.props.currentHealthStep === 1 && <div className="receip-radio-main-row">
              <div className={isReadOnly ? "radioBox disabled" : "radioBox"}>
                <label>
                  <input
                    type="radio"
                    disabled={isReadOnly}
                    name="person"
                    value={'personal'}
                    onChange={() => {
                      const { person } = this.state;
                      this.props.handlePersonChange('physical');
                      person.lastName1.value = (person.lastName1.value === undefined ? '' : person.lastName1.value);
                      person.physicalPerson = true;
                      this.setState({ person });
                      this.handleCheckPerson("personal");
                    }}
                    checked={person.physicalPerson}
                  />
                  <span>PERSONA FÍSICA</span>
                </label>
              </div>
              <div className={isReadOnly ? "radioBox disabled" : "radioBox"}>
                <label>
                  <input
                    type="radio"
                    name="person"
                    value={'legal'}
                    onChange={() => {
                      this.props.handlePersonChange('legal');
                      person.physicalPerson = false;
                      this.setState({ person });
                      this.handleCheckPerson("legal");
                    }}
                    checked={!person.physicalPerson}
                    disabled={isReadOnly}
                  />
                  <span>PERSONA JURÍDICA</span>
                </label>
              </div>
            </div>)}
            {person.physicalPerson ? (
              <div className='personal-data-fisica'>
                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="Nombre"
                        required={true}
                        errorCode={person.name.errorCode}
                        disabled={person.name.disabled || isReadOnly}
                        value={person.name.value}
                        onChange={(value: string) => this.handleValueChange('name', value)}
                      />
                    </div>
                  </div>

                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="Apellido 1"
                        required={true}
                        errorCode={person.lastName1.errorCode}
                        disabled={person.lastName1.disabled || isReadOnly}
                        value={person.lastName1.value}
                        onChange={(value: string) => this.handleValueChange('lastName1', value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="Apellido 2"
                        required={person.nationality && person.nationality.code === "ESPA"}
                        errorCode={person.lastName2.errorCode}
                        disabled={person.lastName2.disabled || isReadOnly}
                        value={person.lastName2.value}
                        onChange={(value: string) => this.handleValueChange("lastName2", value)
                        }
                      />
                    </div>
                  </div>

                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <CalendarBox
                        initialValue={person.birthDate.value}
                        placeholder="Fecha de nacimiento"
                        forbidFutureDates
                        minAge={this.props.insured ? 0 : 18}
                        maxDate={moment().toISOString()}
                        required={true}
                        disabled={person.birthDate.disabled || isReadOnly}
                        errorCode={person.birthDate.errorCode}
                        onChange={(value: string) => this.handleValueChange('birthDate', value)}
                        health={true}
                      />
                    </div>
                  </div>
                </div>

                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="personal-data-item col-25">
                      <DicotomicButton
                        required={true}
                        labelText="Sexo"
                        options={genderOptions}
                        withTab={true}
                        disabled={person.sex.disabled || isReadOnly}
                        initialValue={person.sex.value}
                        onChange={(value: string) => this.handleValueChange('sex', value)}
                        errorCode={person.sex.errorCode}
                      />
                    </div>
                  </div>
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <SearchBox
                        onChange={(ev: any) =>
                          this.changeValueSearchBox(
                            ev,
                            "contact",
                            "nationality"
                          )
                        }
                        labelText=""
                        optionsText={countriesFiltered}
                        optionKey={"value"}
                        optionValue={"label"}
                        disabled={person.nationality.disabled || isReadOnly}
                        initialValue={person.nationality.value}
                        required={true}
                        errorCode={person.nationality.errorCode}
                        onSelect={(value: any) =>
                          this.handleValueChange("nationality", value)
                        }
                      />
                      <label>Nacionalidad</label>
                    </div>
                  </div>
                </div>

                <div className="personal-data-container">
                  <div className="personal-data-row">
                    <div className="personal-data-item col-50">
                      <div className="selectBox">
                        <SelectBox
                          placeholder="Documento de identidad"
                          required={true}
                          errorCode={person.docType.errorCode}
                          optionsText={this.getDocTypes(person.birthDate.value, person.nationality.code)}
                          optionKey={"value"}
                          optionValue={"label"}
                          initialValue={person.docType.value}
                          defaultValue={person.docType.value}
                          disabled={person.docType.disabled || isReadOnly}
                          onChange={(value: string) => this.handleValueChange('docType', value)}
                        />
                        <label>{"Documento de identidad"}</label>
                      </div>
                    </div>
                    <div className="personal-data-item col-50">
                      <div className="inputBox">
                        <InputBox
                          placeholder="Nº de documento"
                          required={person.docType.value !== 'MENOR'}
                          errorCode={person.docNumber.errorCode}
                          maxLength={DOC_NUMBER_MAX_LENGTH}
                          value={person.docType.value !== 'MENOR' ? person.docNumber.value : ''}
                          disabled={person.docNumber.disabled || person.docType.value === 'MENOR' || isReadOnly}
                          onChange={(value: string) => this.handleValueChange('docNumber', value)}
                          type={person.docType.value === 'NIF' ?
                            "NIF" : person.docType.value === 'NIE' ?
                              "NIE" : person.docType.value === 'PAS' ?
                                "PAS" : "NIF"}
                        />
                      </div>
                    </div>

                    {(person.docType.value === 'PAS') &&
                      <div className="personal-data-item col-50">
                        <div className="inputBox">
                          <CalendarBox
                            initialValue={person.passportDate.value}
                            placeholder="Fecha de caducidad del pasaporte"
                            minDate={moment().toISOString()}
                            required={true}
                            disabled={person.passportDate.disabled || isReadOnly}
                            errorCode={person.passportDate.errorCode}
                            onChange={(value: string) => this.handleValueChange('passportDate', value)}
                            health={true}
                          />
                        </div>
                      </div>
                    }

                  </div>
                  {this.props.insured && (
                    <div className="personal-data-row">
                      <div className="personal-data-item col-50">
                        <div className="selectBox">
                          <SearchBox
                            onChange={(ev: any) =>
                              this.changeValueSearchBox(
                                ev,
                                "occupation",
                                "profession",
                              )
                            }
                            labelText=""
                            required={false}
                            errorCode={person.profession.errorCode}
                            optionsText={professionsFiltered}
                            optionKey={"value"}
                            optionValue={"label"}
                            initialValue={person.profession.value}
                            onSelect={(value: any) =>
                              this.handleValueChange("profession", value)
                            }
                            disabled={person.profession.disabled || isReadOnly}
                          />
                          <label>{"Profesión"}</label>
                        </div>
                      </div>
                      {deepGet(productFields, "step2.repatriationCountry", false) && (
                        <div className="personal-data-item col-50">
                          <div className="inputBox">
                            {deepGet(productFields, "step2.repatriationCountry.tooltip", "") && (
                              <LabelTooltip
                                showTooltip={() => this.setState({ showRepatriationTooltip: true})}
                                hideTooltip={() => this.setState({ showRepatriationTooltip: false })}
                                tooltipTitle={deepGet(productFields, "step2.repatriationCountry.tooltip", "")}
                                isTooltipVisible={showRepatriationTooltip}
                                tooltipIconTop="-25px"
                                tooltipIconLeft="200px"
                              />
                            )}
                            <SearchBox
                              onChange={(ev: any) =>
                                this.changeValueSearchBox(
                                  ev,
                                  "contact",
                                  "repatriationCountry"
                                )
                              }
                              labelText=""
                              optionsText={repatriationCountriesFiltered}
                              optionKey={"value"}
                              optionValue={"label"}
                              initialValue={person.repatriationCountry && person.repatriationCountry.value}
                              required={deepGet(productFields, "step2.repatriationCountry.required", false)}
                              errorCode={person.repatriationCountry && person.repatriationCountry.errorCode}
                              onSelect={(value: any) =>
                                this.handleValueChange("repatriationCountry", value)
                              }
                            />
                            <label>País de repatriación</label>
                            
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className='personal-data-juridica'>
                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="Razón Social"
                        required={true}
                        errorCode={person.name.errorCode}
                        disabled={person.name.disabled || isReadOnly}
                        value={person.name.value}
                        onChange={(value: string) => this.handleValueChange("name", value)
                        }
                        type={"numbersletter"}
                      />
                    </div>
                  </div>

                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="CIF"
                        required={true}
                        errorCode={person.docNumber.errorCode}
                        disabled={person.docNumber.disabled || isReadOnly}
                        value={person.docNumber.value}
                        onChange={(value: string) => this.handleValueChange("docNumber", value)
                        }
                        type={"text"}
                        maxLength={DOC_NUMBER_MAX_LENGTH}
                      />
                    </div>
                  </div>

                </div>

                <div className="personal-data-row">

                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        errorCode={person.responsable.errorCode}
                        onChange={(value: string) => this.handleValueChange("responsable", value)}
                        placeholder="RESPONSABLE"
                        required
                        disabled={person.responsable.disabled || isReadOnly}
                        type={"letters"}
                        value={person.responsable.value}
                      />
                    </div>
                  </div>

                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        onChange={(value: string) => this.handleValueChange("tc2", value)}
                        placeholder="T.C.2"
                        type={"text"}
                        disabled={person.tc2.disabled || isReadOnly}
                        value={person.tc2.value}
                      />
                    </div>
                  </div>
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        onChange={(value: string) => this.handleValueChange("reta", value)}
                        placeholder="R.E.T.A"
                        type={"text"}
                        disabled={person.reta.disabled || isReadOnly}
                        value={person.reta.value}
                      />
                    </div>
                  </div>
                </div>

              </div>
            )}
          </div>
        </div>
      </PersonalInformationContainer>
    )
  }
}

export default withGeneral(withDynamicProducts(PersonalInformation));
